export const appInfo = {
    appName: "SPARLON",
    email: "info@sparloon.com",
    mobileNo: "+8801987987987",
    telephoneNo: "+88002224422475",
    address: "Mirpur, Dhaka, Bangladesh",
    website: "https://sparloon.com",
    
    baseUrl: process.env.REACT_APP_API_URL || "http://127.0.0.1:8855/api",
    authUrl: process.env.REACT_APP_AUTH_URL || "http://127.0.0.1:8642/api",
    locationUrl: process.env.REACT_APP_LOCATION_URL || "https://locations.nityodin.com/",
    dashboardUrl: process.env.REACT_APP_DASHBOARD_URL || "http://127.0.0.1:3001/direct-login",
    localStorageEncryptionKey: "local-storage-data-encryption-key-123"
};
